import * as React from "react"
const SvgComponent = ({fill="#5C5C5C", ...props}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8}
    height={14}
    fill="none"
    {...props}
  >
    <path
      fill={fill}
      fillOpacity={0.7}
      d="m2.885 7.04 4.79 4.79-1.368 1.367L.148 7.04 6.308.883 7.674 2.25l-4.79 4.79Z"
      opacity={0.67}
    />
  </svg>
)
export default SvgComponent
